import { chartHelper } from 'helpers';
import { Box, ErrorFormField, Sidebar } from 'components/common';
import { ELSButton, ELSFlex, ELSFlexItem } from 'components/common/els';
import { ChartViewProps } from 'components/features/shared/constants';
import { BLOCK, PRODUCT_REQUEST_COMPONENTS, getPlaceholderClass } from './constants';
import SidebarActions from './SidebarActions';

export interface ProductRequestSidebarViewProps extends Partial<ChartViewProps> {
  isSidebarOpen: boolean;
  onCloseClick: Function;
  sidebarProps: Function;
}

const ProductRequestSidebarView = (props: ProductRequestSidebarViewProps) => {
  const { formFieldMap, formSubmittedCount, isSidebarOpen, onCloseClick, sidebarProps } = props;
  const handleClose = () => chartHelper.handleCloseSidebar({ sidebarProps, onCloseClick });

  return (
    <Sidebar open={isSidebarOpen} onClose={handleClose} sidebarProps={sidebarProps} hideCloseButton>
      <ELSFlex className={`${BLOCK}__sidebar-header`} middle spaceBetween>
        <ELSFlexItem>
          <h2>Add Product Request</h2>
        </ELSFlexItem>
        <ELSFlexItem>
          <ELSButton type="debuttonize" ariaLabel="Close" iconName="close" iconPrefix="hmds" iconSize="1x" onClick={handleClose} />
        </ELSFlexItem>
      </ELSFlex>
      <Box className={`${BLOCK}__sidebar-form`}>
        {PRODUCT_REQUEST_COMPONENTS.map((component) => (
          <Box key={component.key} className={`${BLOCK}__sidebar-group`}>
            <ELSFlex left wrap className="u-els-margin-bottom">
              <ELSFlexItem w="1o2" md="1o1">
                <ErrorFormField className="u-els-padding-right" formField={formFieldMap.get(component.detailField)} formSubmittedCount={formSubmittedCount} />
              </ELSFlexItem>
              <ELSFlexItem w="1o2" md="1o1">
                <ErrorFormField formField={formFieldMap.get(component.unitsField)} formSubmittedCount={formSubmittedCount} />
              </ELSFlexItem>
            </ELSFlex>
            <ELSFlex left wrap>
              <ELSFlexItem w="1o2" md="1o1">
                <div className={getPlaceholderClass(formFieldMap.get(component.dayField))}>
                  <ErrorFormField className="u-els-padding-right" formField={formFieldMap.get(component.dayField)} formSubmittedCount={formSubmittedCount} />
                </div>
              </ELSFlexItem>
              <ELSFlexItem w="1o2" md="1o1">
                <div className={getPlaceholderClass(formFieldMap.get(component.timeField))}>
                  <ErrorFormField formField={formFieldMap.get(component.timeField)} formSubmittedCount={formSubmittedCount} />
                </div>
              </ELSFlexItem>
            </ELSFlex>
          </Box>
        ))}
        <Box className={`${BLOCK}__sidebar-actions`}>
          <SidebarActions {...props.chartActionsProps} />
        </Box>
      </Box>
    </Sidebar>
  );
};

export default ProductRequestSidebarView;
